import useFetch from "../../hooks/useFetch";
import React from "react";
import {
  Dialog, DialogTitle, DialogContent,
  DialogActions, Button, TextField
} from "@mui/material";
import "./Stores.css";


const StoreCommissionDialog: React.FC<{
  open: boolean;
  storeId: number;
  currentRate: number | null;
  onClose: () => void;
  onSave: (newRate: number) => void;
}> = ({ open, storeId, currentRate, onClose, onSave }) => {
  const [value, setValue] = React.useState(String(currentRate ?? ""));

  React.useEffect(() => {
    if (open) setValue(String(currentRate ?? ""));
  }, [open, currentRate]);

  const { fetchData: updateCommission, errorContent } = useFetch({
    url: `${import.meta.env.VITE_API_URL}/stores/update-store-profile/${storeId}`,
    method: "PUT",
  });

  const [showError, setShowError] = React.useState(false);

  React.useEffect(() => {
    if (open) { setValue(String(currentRate ?? "")); setShowError(false); }
  }, [open, currentRate]);

  const handleSave = async () => {
    const parsed = parseFloat(value);
    if (isNaN(parsed)) return;
    const result = await updateCommission({ commission_rate: parsed });
    if (result?.success) {
      onSave(parsed);
      onClose();
    } else {
      setShowError(true);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth disableScrollLock
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}>
      <DialogTitle sx={{ fontFamily: "Montserrat, sans-serif", fontSize: 15, fontWeight: 600, pb: 0 }}>
        Set Commission Store #{storeId}
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <TextField
          autoFocus fullWidth
          label="Commission %"
          type="number"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") handleSave(); }}
          variant="outlined"
          size="small"
          InputProps={{ inputProps: { min: 0, max: 100, step: 0.1 } }}
          sx={{ mt: 1, fontFamily: "Montserrat, sans-serif" }}
        />
        {showError && errorContent && (
          <div className="commission-dialog-error">
            {errorContent}
          </div>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} size="small"
          sx={{ fontFamily: "Montserrat, sans-serif", color: "#888", textTransform: "none" }}>
          Cancel
        </Button>
        <Button onClick={handleSave} size="small" variant="contained" disableElevation
          sx={{ fontFamily: "Montserrat, sans-serif", textTransform: "none",
            backgroundColor: "#000", "&:hover": { backgroundColor: "#333" } }}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StoreCommissionDialog;